import { z } from "zod";

export const unlockSchema = z.object({
  code: z.string().trim().min(1, "Enter the private preview code.").max(256, "The access code is too long."),
});

export type UnlockForm = z.infer<typeof unlockSchema>;
